/**
 * Shape of an account_members row joined to its account's status, as returned
 * by `.select('account_id, accounts(status)')` under the caller's own RLS.
 */
export interface MembershipAccountRow {
  accounts: { status: string } | null;
}

/**
 * True when the user HAS account memberships but none of them is on a
 * non-suspended account — i.e. every workspace they belong to is locked.
 *
 * RLS hides suspended accounts from their members (the account_belongs_to_me
 * guard in migration 20261031213000), so under a dealer's own session a
 * suspended account surfaces as a NULL `accounts` join rather than an
 * explicit status. Treat null and 'suspended' the same so the check also
 * behaves correctly against a database that predates that migration.
 *
 * A dealer with zero memberships returns false — they keep today's behavior
 * (sign-in allowed, friendly empty states) rather than a suspension message.
 */
export function allAccountsSuspended(rows: MembershipAccountRow[] | null | undefined): boolean {
  if (!rows || rows.length === 0) return false;
  return rows.every((r) => !r.accounts || r.accounts.status === 'suspended');
}
